import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'navaar-image-icon',
  template:`<svg [ngStyle]="style" xmlns="http://www.w3.org/2000/svg" width="33.828" height="40.244" viewBox="0 0 33.828 40.244">
  <g id="Group_4023" data-name="Group 4023" transform="translate(-540.006 -327.001)">
    <path id="Path_3107" data-name="Path 3107" d="M573.826,347.385c0,5.138.015,10.276-.005,15.414-.011,2.932-1.542,4.42-4.582,4.428q-10.917.03-21.835,0a7.029,7.029,0,0,1-7.367-7.069c-.03-7.52-.053-15.042.006-22.562.049-6.3,4.456-10.493,11.072-10.555,5.947-.057,11.9-.037,17.844,0,3.3.019,4.842,1.527,4.86,4.714C573.848,336.96,573.826,342.172,573.826,347.385Zm-4.294-16.371c-6.537,0-12.8-.067-19.055.025a6.074,6.074,0,0,0-6.251,6.228c-.063,4.244-.016,8.49-.017,12.734,0,1.222,0,2.444,0,3.243h25.323Zm.028,26.3c-.677-.061-1.283-.162-1.89-.163-6.408-.012-12.815-.024-19.223,0-2.659.011-4.182,1.111-4.21,2.919-.029,1.874,1.662,3.168,4.247,3.175,5.939.017,11.877.005,17.816.005h3.261Z" fill="#3f3e43"/>
    <path id="Path_3108" data-name="Path 3108" d="M569.236,356.845c0-1.184-.023-2.369.006-3.553.037-1.472.813-1.9,2.112-1.13,1.912,1.134,3.77,2.353,5.632,3.562,1.2.776.989,1.538-.11,2.235-1.811,1.149-3.6,2.326-5.441,3.436-1.481.9-2.165.309-2.2-1.219C569.219,359.066,569.236,357.955,569.236,356.845Z" transform="translate(-15.484 -13.698)" fill="#3f3e43"/>
  </g>
</svg>
`
})
export class ImageIconComponent implements OnInit {
  @Input() public style: object = {};
  constructor() { }

  ngOnInit(): void {
  }

}
